(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primary-inductance-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('primary-inductance-calculator')) {
    customElements.define('primary-inductance-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('pagehide', this.pageHideListener);
          this.resizeObserver?.observe(this.svg);
          this.parameterObserver?.observe(this.parameterDiagram);
          this.querySelectorAll('[data-parameter-control]').forEach(node=>this.parameterObserver?.observe(node));
          this.drawingKey = null;
          this.onInput({dataset:{field:'material'}});
          return;
        }
        this.initialized = true;
        this.sequence = 0;
        this.controller = null;
        this.timer = null;
        this.geometryTimer = null;
        this.geometryController = null;
        this.geometryRevision = 0;
        this.pcbGeometry = null;
        this.currentMaterial = 'round';
        this.currentConductorForm='tube';this.dataset.conductorForm='tube';
        this.currentShape = 'flat';
        this.flatMaterial = 'round';
        this.dataset.conductor = this.currentMaterial;
        this.pcbResultCache = new Map();
        this.cacheVersion = null;
        this.roundValues = { spiral_start_centerline_diameter_mm: 106, physical_turns: 6.25, start_turn: 0, end_turn: 6.25 };
        this.pcbValues = { spiral_start_centerline_diameter_mm: 6, physical_turns: 125, start_turn: 0, end_turn: 125 };
        this.dragging = null;
        this.dragFrame = null;
        this.pendingPointer = null;
        this.activePointerId = null;
        this.interactionController = null;
        this.svg = this.querySelector('[data-spiral]');
        this.parameterDiagram = this.querySelector('[data-parameter-diagram]');
        this.parameterSvg = this.querySelector('[data-parameter-svg]');
        this.visual = this.querySelector('[data-visual]');
        this.highTurnSummary = this.querySelector('[data-high-turn]');
        this.highPhysical = this.querySelector('[data-high-physical]');
        this.highActive = this.querySelector('[data-high-active]');
        this.highCylinderPhysical = this.querySelector('[data-high-cylinder-physical]');
        this.highCylinderActive = this.querySelector('[data-high-cylinder-active]');
        this.physicalPath = this.querySelector('[data-physical]');
        this.activePath = this.querySelector('[data-active]');
        this.status = this.querySelector('[data-status]');
        this.message = this.querySelector('[data-message]');
        this.previewReadout = this.querySelector('[data-preview-readout]');
        const copperThickness=this.querySelector('[data-field="copper_thickness_mm"]');
        if(!copperThickness.value)copperThickness.value='0.035';
        this.inputs = [...this.querySelectorAll('[data-field]')];
        this.fieldInputs=Object.fromEntries(this.inputs.map(input=>[input.dataset.field,input]));
        this.displayUnit='mm';this.canonicalDimensions={};
        this.inputs.forEach(input=>this.captureDimensionDraft(input));
        this.handles = {
          start: this.querySelector('[data-handle="start"]'),
          end: this.querySelector('[data-handle="end"]')
        };
        this.hitHandles = {
          start: this.querySelector('[data-hit-handle="start"]'),
          end: this.querySelector('[data-hit-handle="end"]')
        };
        this.inputs.forEach(input=>{
          input.addEventListener('input',()=>input.type==='number'?this.editDraft(input):this.onInput(input));
          if(input.type==='number'){
            input.addEventListener('focus',()=>this.editNumber(input));
            input.addEventListener('blur',()=>{this.formatNumberInput(input);this.queueDraftCommit();});
            input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();input.blur();}});
            this.formatNumberInput(input);
          }
        });
        this.choiceInputs('length-unit').forEach(input=>input.addEventListener('change',event=>this.switchLengthUnit(event.currentTarget.value)));
        this.choiceInputs('copper-weight').forEach(input=>input.addEventListener('change',event=>this.selectCopperWeight(event.currentTarget.value)));
        this.syncCopperWeight();
        this.querySelectorAll('button[data-winding-direction]').forEach(button=>button.addEventListener('click',event=>this.switchWindingDirection(event.currentTarget.dataset.windingDirection)));
        this.choiceInputs('material').forEach(input=>input.addEventListener('change',event=>this.switchMaterial(event.currentTarget.value)));
        this.choiceInputs('shape').forEach(input=>input.addEventListener('change',event=>this.switchShape(event.currentTarget.value)));
        this.choiceInputs('conductor-form').forEach(input=>input.addEventListener('change',event=>this.switchConductorForm(event.currentTarget.value)));
        this.querySelector('[data-calculate]').addEventListener('click', () => this.awaitingDrawing?this.onInput({dataset:{field:'retry'}}):this.requestExact(true));
        this.querySelector('[data-cancel]').addEventListener('click', () => {this.invalidateResult();this.retryAvailable=true;this.updatePcbCompute();});
        this.pageHideListener = () => this.controller?.abort();
        window.addEventListener('pagehide', this.pageHideListener);
        this.draw();
        this.setChoice('length-unit',this.unitName());
        this.setChoice('shape',this.shape());
        this.setChoice('material',this.currentMaterial);
        this.setChoiceDisabled('length-unit',false);
        this.syncPcbUnitChoice();
        this.setChoiceDisabled('shape',false);
        this.querySelectorAll('[data-material]').forEach(input => { input.checked = input.value === this.currentMaterial; input.disabled = false; });
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.svg.getBoundingClientRect().width;
          if (Math.abs(width - (this.drawingScreenWidth || 0)) > .5 && (this.committedDrawing||this.geometryIsValid())) this.draw();
        });
        this.resizeObserver.observe(this.svg);
        this.parameterObserver=new ResizeObserver(()=>this.drawParameterDiagram());
        this.parameterObserver.observe(this.parameterDiagram);
        this.querySelectorAll('[data-parameter-control]').forEach(node=>this.parameterObserver.observe(node));
        this.scheduleExact(0);
      }

      disconnectedCallback() {
        clearTimeout(this.commitTimer);
        this.geometryPending=false;
        this.fieldInputs=null;
        this.highDrawingKey=null;
        this.highDrawingRevision=(this.highDrawingRevision||0)+1;
        cancelAnimationFrame(this.highDrawingFrame);
        window.removeEventListener('pagehide', this.pageHideListener);
        this.resizeObserver?.disconnect();
        this.parameterObserver?.disconnect();
        if (this.dragFrame) cancelAnimationFrame(this.dragFrame);
        this.dragFrame = null;
        this.pendingPointer = null;
        this.sequence += 1;
        this.geometryRevision += 1;
        if (this.geometryController) this.geometryController.abort();
        clearTimeout(this.geometryTimer);
        if (this.interactionController) this.interactionController.abort();
        this.interactionController = null;
        this.dragging = null;
        this.activePointerId = null;
        if (this.controller) this.controller.abort();
        clearTimeout(this.timer);
      }

      bindInteraction() {
        if (this.interactionController) return;
        const controller = new AbortController();
        const options = { signal: controller.signal };
        this.interactionController = controller;
        Object.entries(this.handles).forEach(([name, handle]) => {
          handle.addEventListener('pointerdown', (event) => this.startDrag(name, event), options);
          handle.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
            event.preventDefault();
            const input = this.querySelector(`[data-field="${name}_turn"]`);
            const delta = ['ArrowRight', 'ArrowUp'].includes(event.key) ? .01 : -.01;
            const other = this.number(name === 'start' ? 'end_turn' : 'start_turn');
            input.value = (name === 'start' ? Math.max(0, Math.min(other - .05, Number(input.value) + delta)) : Math.min(this.number('physical_turns'), Math.max(other + .05, Number(input.value) + delta))).toFixed(6);
            this.onInput(input);
          }, options);
        });
        Object.entries(this.hitHandles).forEach(([name, handle]) => {
          handle.addEventListener('pointerdown', (event) => this.startDrag(name, event), options);
        });
        this.svg.addEventListener('pointermove', (event) => this.drag(event), options);
        this.svg.addEventListener('pointerup', (event) => this.stopDrag(event), options);
        this.svg.addEventListener('pointercancel', (event) => this.stopDrag(event), options);
        this.svg.addEventListener('lostpointercapture', (event) => this.stopDrag(event), options);
      }

      unbindInteraction() {
        if (!this.interactionController) return;
        this.interactionController.abort();
        this.interactionController = null;
      }

      number(name) {
        if(this.renderContext)return this.renderContext.values[name];
        this.fieldInputs||={};
        const input=this.fieldInputs[name]||(this.fieldInputs[name]=this.querySelector(`[data-field="${name}"]`)),raw=String(input.value??'').trim();
        if(!raw||input.validity?.badInput)return NaN;
        const record=this.canonicalDimensions?.[name];
        if(record&&record.display===raw)return record.mm;
        return Number(raw)*(name.endsWith('_mm')&&input.dataset?.fixedMm===undefined?this.unitFactor():1);
      }

      choiceInputs(group) {return [...this.querySelectorAll(`input[type="radio"][data-choice-group="${group}"]`)];}
      choiceValue(group) {return this.choiceInputs(group).find(input=>input.checked)?.value||'';}
      setChoice(group,value) {this.choiceInputs(group).forEach(input=>{input.checked=input.value===String(value);});}
      setChoiceDisabled(group,disabled) {this.choiceInputs(group).forEach(input=>{input.disabled=disabled;});}

      unitFactor() {return this.displayUnit==='in'?25.4:this.displayUnit==='mil'?.0254:1;}
      unitName() {return ['in','mil'].includes(this.displayUnit)?this.displayUnit:'mm';}
      displayNumber(value) {return !Number.isFinite(value)?'—':value>0&&value<.001?'<0.001':(Object.is(value,-0)?0:value).toFixed(3);}
      lengthNumber(mm) {return this.displayNumber(mm/this.unitFactor());}
      resultLengthNumber(mm) {return this.lengthNumber(mm);}
      lengthText(mm) {return `${this.lengthNumber(mm)} ${this.unitName()}`;}

      captureDimensionDraft(input) {
        const name=input.dataset?.field;if(!name)return;
        this.canonicalDimensions||={};
        const raw=String(input.value??'').trim(),record=this.canonicalDimensions[name];
        if(record?.display===raw)return;
        const factor=!name.endsWith('_mm')||input.dataset?.fixedMm!==undefined?1:this.unitFactor();
        this.canonicalDimensions[name]={mm:raw&&!input.validity?.badInput?Number(raw)*factor:NaN,display:raw};
        input.mmMinimum??=Number(input.min);input.mmMaximum??=Number(input.max);
      }

      setFieldValue(name,value) {
        const input=this.querySelector(`[data-field="${name}"]`);
        const factor=name.endsWith('_mm')&&input.dataset?.fixedMm===undefined?this.unitFactor():1;
        const display=String(value/factor);
        this.canonicalDimensions||={};this.canonicalDimensions[name]={mm:value,display};input.value=display;
        if(input.type==='number'&&!input.numberEditing)this.formatNumberInput(input);
      }

      editNumber(input) {
        const name=input.dataset.field,value=this.number(name);
        input.numberEditing=true;
        if(Number.isFinite(value))this.setFieldValue(name,value);
        if(input.precisionHint)input.precisionHint.hidden=true;
      }

      formatNumberInput(input) {
        const name=input.dataset.field,value=this.number(name);
        input.numberEditing=false;
        if(!Number.isFinite(value)){if(input.precisionHint)input.precisionHint.hidden=true;return;}
        const factor=name.endsWith('_mm')&&input.dataset?.fixedMm===undefined?this.unitFactor():1;
        const shown=value/factor,display=shown.toFixed(3);
        this.canonicalDimensions||={};this.canonicalDimensions[name]={mm:value,display};input.value=display;
        if(shown>0&&shown<.001&&!input.precisionHint&&input.parentElement){
          input.precisionHint=document.createElement('small');input.precisionHint.dataset.precisionHint='';(input.closest?.('label')||input.parentElement).appendChild(input.precisionHint);
        }
        if(input.precisionHint){input.precisionHint.textContent='<0.001';input.precisionHint.hidden=!(shown>0&&shown<.001);}
      }

      refreshLengthDisplay() {
        this.inputs?.forEach(input=>{
          const name=input.dataset.field;if(!name.endsWith('_mm'))return;
          const value=this.canonicalDimensions?.[name]?.mm;
          if(Number.isFinite(value))this.setFieldValue(name,value);
          if(input.dataset?.fixedMm!==undefined)return;
          if(Number.isFinite(input.mmMinimum))input.min=String(input.mmMinimum/this.unitFactor());
          if(Number.isFinite(input.mmMaximum))input.max=String(input.mmMaximum/this.unitFactor());
        });
        this.querySelectorAll('[data-length-unit]').forEach(node=>node.textContent=node.closest?.('[data-parameter-control]')?this.unitName():` · ${this.unitName()}`);
        this.querySelector('[data-result-length-unit]').textContent=this.unitName();
        for(const name of ['radial','axial'])this.querySelector(`[data-zero-${name}]`).textContent=`${this.lengthText(0)} · ${this.dataset.labelFixed}`;
        if(Number.isFinite(this.resultLengthMm))this.querySelector('[data-result="active_length_mm"]').textContent=this.resultLengthNumber(this.resultLengthMm);
      }

      switchLengthUnit(unit) {
        if(!['mm','in','mil'].includes(unit)||(unit==='mil'&&!this.isPcb())){this.setChoice('length-unit',this.unitName());return;}
        if(unit===this.unitName())return;
        const errors=this.validationErrors(false);
        const pendingGeometry=this.isPcb()&&this.geometryPending&&!this.geometryRejected;
        if(errors.length||(!this.geometryIsValid()&&!pendingGeometry)){
          this.setChoice('length-unit',this.unitName());
          this.displayValidation(errors,true);this.message.textContent=this.dataset.messageUnitBlocked;return;
        }
        this.inputs?.forEach(input=>this.captureDimensionDraft(input));
        this.displayUnit=unit;this.setChoice('length-unit',unit);this.refreshLengthDisplay();this.updatePcbCompute();this.drawingKey=null;
        if(this.draftDirty)this.commitDraft();else this.draw();
      }

      syncCopperWeight() {
        const h=this.number('copper_thickness_mm'),weight=[.5,1,2].find(oz=>Math.abs(h-oz*.035)<1e-12);
        this.setChoice('copper-weight',String(weight||1));
      }

      selectCopperWeight(value) {
        this.setChoice('copper-weight',value);
        const weight=Number(value);if(![.5,1,2].includes(weight)){this.syncCopperWeight();return;}
        this.setFieldValue('copper_thickness_mm',weight*35/1000);
        this.onInput(this.querySelector('[data-field="copper_thickness_mm"]'));
      }

      syncPcbUnitChoice() {
        const pcb=this.isPcb();this.querySelectorAll('[data-pcb-unit]').forEach(node=>{node.hidden=!pcb;});
        const mil=this.querySelector('[data-length-unit-option][value="mil"]');if(mil)mil.disabled=!pcb;
        if(!pcb&&this.unitName()==='mil'){
          this.inputs?.forEach(input=>this.captureDimensionDraft(input));this.displayUnit='mm';this.setChoice('length-unit','mm');this.refreshLengthDisplay();
        }
      }

      isPcb() { return (this.renderContext?.material||this.currentMaterial) === 'pcb'; }
      conductorForm() {return this.renderContext?.form||this.currentConductorForm||'solid';}
      roundWall() {return this.conductorForm()==='tube'?this.number('wall_thickness_mm'):this.number('conductor_od_mm')/2;}
      switchConductorForm(form) {
        if(!['tube','solid'].includes(form)){this.setChoice('conductor-form',this.conductorForm());return;}
        if(form===this.conductorForm())return;
        this.currentConductorForm=form;this.dataset.conductorForm=form;this.setChoice('conductor-form',form);
        this.onInput({dataset:{field:'conductor-form'}});
      }

      fastAvailable() {
        const effective=this.isHighTurnMode()?this.number('physical_turns'):this.number('end_turn')-this.number('start_turn');
        const h=this.number('copper_thickness_mm');
        return h>=.005&&(h<=.07?effective<=500:h<=.21&&effective<=300);
      }

      solverAvailable() { return this.fastAvailable(); }

      updatePcbCompute() {
        const retry=this.querySelector('[data-calculate]'),cancel=this.querySelector('[data-cancel]');
        const geometryRetry=this.isPcb()&&this.awaitingDrawing&&!this.geometryPending&&!this.geometryRejected&&!this.draftDirty&&this.inputsAreValid();
        retry.hidden=!this.retryAvailable;retry.disabled=!geometryRetry&&(this.awaitingDrawing||!this.geometryIsValid()||(this.isPcb()&&!this.solverAvailable())||Boolean(this.controller));
        cancel.hidden=!this.controller;
        this.querySelector('[data-calculate]').textContent = this.dataset.labelFastCalculate;
        let range=this.dataset.messageFastRange||'';
        for(const [key,value]of Object.entries({thin_min:.005,thin_max:.07,thick_max:.21}))range=range.replaceAll(`%${key}%`,this.lengthText(value));
        this.querySelector('[data-fast-range]').textContent = this.isPcb() && (!this.solverAvailable()||this.number('copper_thickness_mm')>.07) ? range : '';
      }

      meshResultValid(result) {
        if (result.solver_mode && result.solver_mode !== 'fast') return false;
        const limits = { cross_section: .005, quadrature: .005 };
        if(this.number('copper_thickness_mm')>.07){limits.thickness=.005;if(result.solver_method!=='pcb_annular_rectangular_thickness_v1')return false;}
        if (result.mesh_checks?.angular !== 'not_applicable') limits.angular = .005;
        return Object.entries(limits).every(([name, limit]) => result.mesh_checks?.[name] === 'passed' && Number.isFinite(result.mesh_errors?.[name]) && result.mesh_errors[name] >= 0 && result.mesh_errors[name] <= limit);
      }

      shape() { return this.renderContext?.shape || this.currentShape || 'flat'; }

      isCylinder() { return this.shape() === 'cylindrical'; }

      pitch() { return this.isPcb() ? this.number('trace_width_mm')+this.number('trace_gap_mm') : (this.isCylinder() ? 0 : this.number('centerline_pitch_mm')); }

      axialPitch() { return this.shape() === 'flat' ? 0 : this.number('axial_pitch_mm'); }

      switchShape(shape) {
        if(!['flat','conical','cylindrical'].includes(shape)){this.setChoice('shape',this.shape());return;}
        if (shape === this.shape()) {this.setChoice('shape',shape);return;}
        if (this.shape() === 'flat') this.flatMaterial = this.currentMaterial;
        this.disablePendingInteraction();
        this.currentShape = shape;
        this.setChoice('shape',shape);
        this.querySelector('[data-material-controls]').hidden = shape !== 'flat';
        const radial = this.querySelector('[data-field="centerline_pitch_mm"]');
        const axial = this.querySelector('[data-field="axial_pitch_mm"]');
        radial.hidden = radial.disabled = this.isCylinder();
        axial.hidden = axial.disabled = shape === 'flat';
        this.querySelector('[data-zero-radial]').hidden = !this.isCylinder();
        this.querySelector('[data-zero-axial]').hidden = shape !== 'flat';
        const material = shape === 'flat' ? this.flatMaterial : 'round';
        if (material !== this.currentMaterial) this.switchMaterial(material);
        else this.onInput({dataset:{field:'shape'}});
      }

      conductorWidth() { return this.number(this.isPcb() ? 'trace_width_mm' : 'conductor_od_mm'); }

      invalidateResult() {
        this.retryAvailable=false;
        this.resultLengthMm=null;
        this.sequence += 1;
        if (this.controller) this.controller.abort();
        this.controller = null;
        clearTimeout(this.timer);
        this.querySelectorAll('[data-result]').forEach((node) => { node.textContent = '—'; });
        this.querySelector('[data-server-diagnostics]').hidden = true;
        this.querySelector('[data-cache-note]').textContent = '';
        this.querySelector('[data-cancel]').disabled = true;
        this.updatePcbCompute();
        this.setStatus('preview');
        this.message.textContent = this.isPcb() ? this.dataset.labelPending : '';
      }

      switchMaterial(material) {
        if(!['round','pcb'].includes(material)){this.setChoice('material',this.currentMaterial);return;}
        if (material === 'pcb' && this.shape() !== 'flat') {this.setChoice('material',this.currentMaterial);return;}
        if (material === this.currentMaterial) {this.setChoice('material',material);return;}
        const names = ['spiral_start_centerline_diameter_mm', 'physical_turns', 'start_turn', 'end_turn'];
        const values = Object.fromEntries(names.map((name) => [name, this.number(name)]));
        if (this.isPcb()) this.pcbValues = values;
        else this.roundValues = values;
        this.currentMaterial = material;
        this.dataset.conductor=material;
        this.setChoice('material',material);
        this.querySelector('[data-field="spiral_start_centerline_diameter_mm"]').mmMinimum=this.isPcb() ? .254 : 10;
        this.querySelector('[data-field="spiral_start_centerline_diameter_mm"]').min=String((this.isPcb() ? .254 : 10)/this.unitFactor());
        this.querySelector('[data-field="spiral_start_centerline_diameter_mm"]').step = 'any';
        for (const [name, value] of Object.entries(this.isPcb() ? this.pcbValues : this.roundValues)) this.setFieldValue(name,value);
        this.acceptedTurns=this.number('physical_turns');
        this.querySelectorAll('[data-pcb]').forEach((node) => node.toggleAttribute('hidden',!this.isPcb()));
        this.querySelectorAll('[data-round]').forEach((node) => node.toggleAttribute('hidden',this.isPcb()));
        this.syncPcbUnitChoice();
        this.onInput({ dataset: { field: 'material' } });
      }

      pcbGeometryPayload() {
        return {...Object.fromEntries(['spiral_start_centerline_diameter_mm', 'trace_width_mm', 'trace_gap_mm', 'copper_thickness_mm', 'physical_turns'].map((name) => [name, this.number(name)])),gap_definition:'nominal_radial'};
      }

      validationErrors(includeTaps=false) {
        const pcb=this.isPcb(),d=this.dataset,errors=[];
        const fields=[['spiral_start_centerline_diameter_mm',pcb ? .254 : 10,3000,d.labelInner,'mm'],['physical_turns',.25,2000,d.labelTurns,'turn'],
          ...(pcb?[['trace_width_mm',.127,50,d.labelPcbWidth,'mm'],['trace_gap_mm',.127,50,d.labelPcbGap,'mm'],['copper_thickness_mm',.005,.5,d.labelPcbThickness,'mm']]:[['conductor_od_mm',.1,50,d.labelConductorDiameter,'mm'],...(!this.isCylinder()?[['centerline_pitch_mm',.1,100,d.labelRadialPitch,'mm']]:[]),...(this.shape()!=='flat'?[['axial_pitch_mm',.1,100,d.labelAxialPitch,'mm']]:[])])];
        const format=(template,values)=>Object.entries(values).reduce((text,[k,v])=>text.replaceAll(`%${k}%`,String(v)),template||'');
        const add=(names,template,values)=>errors.push({fields:names,message:format(template,values)});
        if(!pcb&&this.conductorForm()==='tube'&&(!Number.isFinite(this.roundWall())||this.roundWall()<=0||this.roundWall()>=this.number('conductor_od_mm')/2))add(['wall_thickness_mm','conductor_od_mm'],d.errorWall,{});
        for(const [name,min,max,label,unit]of fields){
          const input=this.querySelector(`[data-field="${name}"]`),raw=String(input.value).trim(),value=this.number(name);
          if(!raw||input.validity?.badInput||!Number.isFinite(value))add([name],d.errorFinite,{label,value:raw||'∅'});
          else if(value<min||value>max)add([name],d.errorRange,{label,value:unit==='mm'?this.lengthNumber(value):value,min:unit==='mm'?this.lengthNumber(min):min,max:unit==='mm'?this.lengthNumber(max):max,unit:unit==='mm'?this.unitName():unit});
        }
        if(errors.length)return errors;
        const inner=this.number('spiral_start_centerline_diameter_mm'),w=this.conductorWidth(),n=this.number('physical_turns');
        const pr=Number.isFinite(this.pitch())?this.pitch():this.number('trace_width_mm')+this.number('trace_gap_mm'),pz=this.axialPitch();
        if(inner<2*w)add(['spiral_start_centerline_diameter_mm',pcb?'trace_width_mm':'conductor_od_mm'],d.errorDiameter,{value:this.lengthNumber(inner),minimum:this.lengthNumber(2*w),unit:this.unitName()});
        if(Math.hypot(pr,pz)<w)add(pcb?['trace_width_mm','trace_gap_mm']:['conductor_od_mm',...(this.isCylinder()?[]:['centerline_pitch_mm']),...(this.shape()==='flat'?[]:['axial_pitch_mm'])],d.errorSpacing,{value:this.lengthNumber(Math.hypot(pr,pz)),minimum:this.lengthNumber(w),unit:this.unitName()});
        const envelope=inner+2*pr*n+w,height=n*pz+w;
        if(envelope>5000)add(['physical_turns','spiral_start_centerline_diameter_mm',pcb?'trace_width_mm':'centerline_pitch_mm'],d.errorEnvelope,{value:this.lengthNumber(envelope),limit:this.lengthNumber(5000),unit:this.unitName(),maximum:Math.max(0,(5000-inner-w)/(2*pr)).toFixed(3)});
        if(height>5000)add(['physical_turns','axial_pitch_mm',pcb?'trace_width_mm':'conductor_od_mm'],d.errorHeight,{value:this.lengthNumber(height),limit:this.lengthNumber(5000),unit:this.unitName(),maximum:Math.max(0,(5000-w)/pz).toFixed(3)});
        if(this.shape()==='conical'&&n*pz/envelope>10)add(['physical_turns','axial_pitch_mm'],d.errorAspect,{value:(n*pz/envelope).toFixed(3)});
        if(includeTaps){const start=this.number('start_turn'),end=this.number('end_turn');if(!Number.isFinite(start)||!Number.isFinite(end)||start<0||end>n||end-start<.05-1e-12)add([],d.errorTaps,{start,end,n});}
        return errors;
      }

      displayValidation(errors,stale=errors.length>0) {
        this.querySelector('[data-validation-summary]').textContent=errors.map(e=>e.message).join('\n');
        this.querySelector('[data-stale-preview]').hidden=!stale;
        this.svg.setAttribute('data-stale-preview',String(stale));
        this.inputs?.forEach(input=>{
          if(input.type==='hidden')return;
          const name=input.dataset.field,messages=errors.filter(e=>e.fields.includes(name)).map(e=>e.message);
          input.setAttribute('aria-invalid',String(messages.length>0));
          if(!input.parentElement)return;
          const label=input.closest?.('label')||input.parentElement;
          let error=label.querySelector(`[data-field-error="${name}"]`);
          if(!error){error=document.createElement('small');error.dataset.fieldError=name;error.id=`coil-error-${this.dataset.sectionId||'local'}-${name}`;label.appendChild(error);input.setAttribute('aria-describedby',error.id);}
          error.textContent=messages.join('\n');
          error.title=error.textContent;
        });
      }

      acceptTapSelection() {
        const n=this.number('physical_turns'),start=this.number('start_turn'),end=this.number('end_turn');
        if(n>20||(this.acceptedTurns!==undefined&&n!==this.acceptedTurns)||!Number.isFinite(start)||!Number.isFinite(end)||start<0||end>n||end-start<.05-1e-12){
          this.querySelector('[data-field="start_turn"]').value='0';
          this.querySelector('[data-field="end_turn"]').value=String(n);
        }
        this.acceptedTurns=n;
        this.displayValidation([],false);
      }

      inputsAreValid() {
        return this.validationErrors(false).length===0;
      }

      disablePendingInteraction() {
        this.unbindInteraction();
        cancelAnimationFrame(this.dragFrame);this.dragFrame=null;this.pendingPointer=null;
        const pointer=this.activePointerId;
        this.dragging = null;
        this.activePointerId = null;
        if(pointer!==null&&pointer!==undefined&&this.svg.hasPointerCapture?.(pointer))this.svg.releasePointerCapture(pointer);
        for (const name of ['start', 'end']) {
          this.handles[name].toggleAttribute('hidden', true);
          this.querySelector(`[data-tap-label="${name}"]`).toggleAttribute('hidden', true);
          this.handles[name].setAttribute('aria-disabled', 'true');
          this.hitHandles[name].toggleAttribute('hidden', true);
          this.handles[name].setAttribute('tabindex', '-1');
        }
      }

      async requestPcbGeometry(revision) {
        if (!this.isPcb() || revision !== this.geometryRevision || !this.inputsAreValid()) return;
        const endpoint = this.endpoint('pcb-geometry');
        if (!endpoint) { this.geometryPending=false;this.setStatus('error'); this.message.textContent = this.dataset.messageNoEndpoint; return; }
        const controller = new AbortController();
        this.geometryController = controller;
        this.geometryPending=true;
        try {
          const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.pcbGeometryPayload()), signal: controller.signal });
          const result = await response.json();
          if (revision !== this.geometryRevision || !this.isPcb() || controller.signal.aborted) return;
          this.geometryPending=false;
          if (!response.ok || result.ok === false) {const error=new Error(typeof result.detail==='string'?result.detail:JSON.stringify(result.detail||result));error.geometryRejected=response.status===400||response.status===422;throw error;}
          if (!Number.isFinite(result.radial_pitch_mm)) throw new Error(this.dataset.messageServerGeometry);
          if(result.gap_definition!=='nominal_radial'||Math.abs(result.radial_pitch_mm-this.pitch())>1e-10)throw new Error(this.dataset.messageServerGeometry);
          if (!Array.isArray(result.section_points) || result.section_points.length > 160 || result.section_points.some(point => !Array.isArray(point) || point.length !== 5 || point.some(value => !Number.isFinite(value)) || point[3] >= point[4])) throw new Error('Invalid section geometry');
          this.pcbGeometry = result;
          this.geometryRejected=false;
          const errors=this.validationErrors(false);
          if(errors.length){this.displayValidation(errors,true);this.disablePendingInteraction();this.setStatus('invalid');return;}
          this.acceptTapSelection();
          this.awaitingDrawing=false;
          this.draw();
          this.updatePcbCompute();
          this.setStatus('preview');
          this.message.textContent = this.dataset.labelPending;
          this.scheduleExact(400);
        } catch (error) {
          if (controller.signal.aborted || revision !== this.geometryRevision) return;
          this.geometryPending=false;this.geometryRejected=Boolean(error.geometryRejected);
          this.pcbGeometry = null;
          this.querySelector('[data-calculate]').disabled = true;
          this.setStatus('error');
          this.displayValidation([],true);
          this.disablePendingInteraction();
          this.setStatus(error.geometryRejected ? 'invalid' : 'error');
          this.message.textContent = `${error.geometryRejected?this.dataset.messageServerGeometry:this.dataset.messageNetwork} ${error.message}`;
          this.retryAvailable=!error.geometryRejected;this.updatePcbCompute();
        }
      }

      editDraft(input) {
        this.captureDimensionDraft(input);
        this.draftDirty=true;this.awaitingDrawing=true;
        clearTimeout(this.commitTimer);clearTimeout(this.geometryTimer);
        this.geometryRevision+=1;this.geometryController?.abort();this.geometryPending=false;
        this.invalidateResult();this.disablePendingInteraction();
        this.displayValidation([],true);
      }

      queueDraftCommit() {
        if(!this.draftDirty)return;
        clearTimeout(this.commitTimer);
        // Blur precedes radio change/click. Commit once after that native event sequence.
        this.commitTimer=setTimeout(()=>this.commitDraft(),0);
      }

      commitDraft() {
        clearTimeout(this.commitTimer);
        if(this.draftDirty)this.onInput({dataset:{field:'draft'}});
      }

      withDrawingSnapshot(snapshot,render) {
        const previous=this.renderContext;this.renderContext=snapshot;
        try{return render();}finally{this.renderContext=previous;}
      }

      captureDrawing() {
        return {values:Object.fromEntries(this.inputs.map(input=>[input.dataset.field,this.number(input.dataset.field)])),shape:this.shape(),material:this.currentMaterial,form:this.conductorForm(),pcbGeometry:this.pcbGeometry};
      }

      onInput(input) {
        clearTimeout(this.commitTimer);this.draftDirty=false;this.awaitingDrawing=true;
        this.geometryPending=false;this.geometryRejected=false;
        this.captureDimensionDraft(input);
        if(input.dataset.field==='copper_thickness_mm')this.syncCopperWeight();
        this.disablePendingInteraction();
        this.highDrawingRevision=(this.highDrawingRevision||0)+1;
        cancelAnimationFrame(this.highDrawingFrame);
        this.highDrawingKey=null;
        this.invalidateResult();
        this.geometryRevision += 1;
        if (this.geometryController) this.geometryController.abort();
        clearTimeout(this.geometryTimer);
        if(this.isPcb()&&!['start_turn','end_turn'].includes(input.dataset.field))this.pcbGeometry=null;
        const errors=this.validationErrors(false);
        if(errors.length){this.displayValidation(errors,true);this.disablePendingInteraction();this.setStatus('invalid');this.message.textContent='';return;}
        this.displayValidation([],true);
        if (this.isPcb()) {
          const geometryChanged = !['start_turn', 'end_turn'].includes(input.dataset.field);
          if (geometryChanged) this.pcbGeometry = null;
          if (!this.pcbGeometry) {
            this.querySelector('[data-calculate]').disabled = true;
            this.disablePendingInteraction();
            const revision = this.geometryRevision;
            this.geometryPending=true;
            this.geometryTimer = setTimeout(() => this.requestPcbGeometry(revision), 250);
            return;
          }
        }
        this.acceptTapSelection();
        if (!this.geometryIsValid()) {
          if (this.controller) this.controller.abort();
          clearTimeout(this.timer);
          this.setStatus('invalid');
          this.message.textContent = this.dataset.messageInvalidGeometry;
          this.disablePendingInteraction();
          return;
        }
        this.awaitingDrawing=false;
        this.draw();
        this.setStatus('preview');
        this.scheduleExact(400);this.updatePcbCompute();
      }

      isHighTurnMode() {
        return this.number('physical_turns') > 20;
      }

      geometryIsValid() {
        if(this.renderContext)return true; // Only validated snapshots enter the renderer.
        if(this.isPcb()&&!this.pcbGeometry)return false;
        if (!this.inputsAreValid()) return false;
        const inner = this.number('spiral_start_centerline_diameter_mm');
        const pitch = this.pitch();
        const conductor = this.conductorWidth();
        const turns = this.number('physical_turns');
        const start = this.number('start_turn');
        const end = this.number('end_turn');
        return inner >= 2 * conductor
          && Math.hypot(pitch, this.axialPitch()) >= conductor
          && inner + 2 * pitch * turns + conductor <= 5000
          && this.axialPitch() * turns + conductor <= 5000
          && (this.shape() !== 'conical' || this.axialPitch() * turns / (inner + 2 * pitch * turns + conductor) <= 10)
          && start >= 0
          && end <= turns
          && end - start >= 0.05 - 1e-12;
      }

      updateInteractionMode() {
        const highTurn = this.isHighTurnMode();
        if(highTurn&&!this.renderContext){this.querySelector('[data-field="start_turn"]').value='0';this.querySelector('[data-field="end_turn"]').value=String(this.number('physical_turns'));}
        this.visual.hidden = false;
        this.highTurnSummary.hidden = !highTurn;
        if (highTurn) this.unbindInteraction();
        else this.bindInteraction();
        for (const name of ['start', 'end']) {
          this.handles[name].setAttribute('tabindex', highTurn ? '-1' : '0');
          this.handles[name].toggleAttribute('hidden', highTurn);
          this.handles[name].setAttribute('aria-disabled', String(highTurn));
          this.querySelector(`[data-tap-label="${name}"]`).toggleAttribute('hidden', highTurn);
          this.hitHandles[name].toggleAttribute('hidden', highTurn);
        }
        if (highTurn) {
          this.dragging = null;
          this.activePointerId = null;
          const inner = this.number('spiral_start_centerline_diameter_mm');
          const outer = inner + 2 * this.pitch() * this.number('physical_turns');
          this.querySelector('[data-high-turn-value="inner"]').textContent = this.lengthText(inner);
          this.querySelector('[data-high-turn-value="outer"]').textContent = this.lengthText(outer);
        }
        return highTurn;
      }

      samples() {
        const turns = Math.max(0.1, this.number('physical_turns'));
        const count = Math.max(120, Math.ceil(turns * 120));
        const startRadius = this.number('spiral_start_centerline_diameter_mm') / 2;
        const pitch = this.pitch();
        return Array.from({ length: count + 1 }, (_, index) => {
          const turn = turns * index / count;
          return this.pointAt(turn);
        });
      }

      path(points) {
        return points.map((point, index) => `${index ? 'L' : 'M'} ${point.x.toFixed(3)} ${point.y.toFixed(3)}`).join(' ');
      }

      displayPlan(radius, screenWidth) {
        const n=this.number('physical_turns'), scale=screenWidth/(2*radius);
        const outer=this.number('spiral_start_centerline_diameter_mm')/2+this.pitch()*n;
        const samples=Math.max(24,Math.ceil(2*Math.PI*Math.sqrt((outer+this.pitch()/Math.PI)*scale/(8*.35))));
        if(!this.isHighTurnMode())return {mode:'full',samples:120,turns:[],count:Math.ceil(n*120)+1};
        const available=Math.floor(11999/n),screenPitch=this.isCylinder()?this.axialPitch():this.pitch(),pitchPixels=screenPitch*scale;
        if(available>=24&&pitchPixels>=.8){const perTurn=Math.min(samples,available);return {mode:'continuous',samples:perTurn,turns:[],count:Math.ceil(n*perTurn)+1};}
        return {mode:'envelope',samples:0,turns:[],count:0};
      }

      renderHighWindings(plan) {
        const continuous=plan.mode==='continuous',envelope=plan.mode==='envelope';
        const physicalBack=this.querySelector('[data-physical-back]'),activeBack=this.querySelector('[data-active-back]');
        const spacing=this.isCylinder()?this.axialPitch():this.pitch();
        const stroke=continuous?Math.max(this.conductorWidth(),Math.min(this.screenPixelsToSvgUnits(.8),spacing*.6)):this.conductorWidth();
        for(const path of [this.physicalPath,this.activePath,physicalBack,activeBack]){
          path.style.fill='none';
          path.setAttribute('stroke-width',String(stroke));
        }
        const key=JSON.stringify([this.drawingKey,this.number('start_turn'),this.number('end_turn'),plan.mode]);
        const ringEnvelope=envelope&&!this.isCylinder(),cylinderEnvelope=envelope&&this.isCylinder();
        this.highPhysical.toggleAttribute('hidden',!ringEnvelope);this.highActive.toggleAttribute('hidden',!ringEnvelope);
        this.highCylinderPhysical.toggleAttribute('hidden',!cylinderEnvelope);this.highCylinderActive.toggleAttribute('hidden',!cylinderEnvelope);
        this.highPhysical.setAttribute('data-envelope',String(envelope));this.highActive.setAttribute('data-envelope',String(envelope));
        if(envelope){
          cancelAnimationFrame(this.highDrawingFrame);this.highDrawingRevision=(this.highDrawingRevision||0)+1;this.highDrawingKey=key;
          for(const path of [this.physicalPath,this.activePath,physicalBack,activeBack])path.setAttribute('d','');
          if(cylinderEnvelope){
            const conductor=this.conductorWidth(),radius=this.number('spiral_start_centerline_diameter_mm')/2,height=this.axialPitch()*this.number('physical_turns');
            for(const node of [this.highCylinderPhysical,this.highCylinderActive]){node.setAttribute('x',String(-radius-conductor/2));node.setAttribute('y',String(-height-conductor/2));node.setAttribute('width',String(2*radius+conductor));node.setAttribute('height',String(height+conductor));}
          }else{
            const inner=this.number('spiral_start_centerline_diameter_mm')/2-this.conductorWidth()/2,outer=inner+this.pitch()*this.number('physical_turns')+this.conductorWidth();
            for(const node of [this.highPhysical,this.highActive]){node.setAttribute('cx','0');node.setAttribute('cy','0');node.setAttribute('r',String((inner+outer)/2));node.setAttribute('stroke-width',String(outer-inner));}
          }
          this.svg.setAttribute('data-envelope-copper-fraction',String(Math.min(1,this.conductorWidth()/spacing)));
          this.svg.setAttribute('data-display-point-count','0');this.svg.setAttribute('data-render-ready','true');return;
        }
        this.svg.removeAttribute('data-envelope-copper-fraction');
        if(this.highDrawingKey===key)return;
        this.highDrawingKey=key;
        cancelAnimationFrame(this.highDrawingFrame);
        const revision=this.highDrawingRevision=(this.highDrawingRevision||0)+1;
        this.svg.setAttribute('data-render-ready','false');
        const physical=[],active=[],start=this.number('start_turn'),end=this.number('end_turn'),n=this.number('physical_turns');
        let index=0,count=0;
        const segment=(lo,hi)=>{
          const size=Math.max(1,Math.ceil((hi-lo)*plan.samples));
          return Array.from({length:size+1},(_,i)=>this.pointAt(lo+(hi-lo)*i/size));
        };
        const ranges=Array.from({length:Math.ceil(n)},(_,i)=>i);
        const append=(target,points)=>target.push(...(target.length?points.slice(1):points));
        const snapshot=this.renderContext||this.captureDrawing();
        const step=()=>this.withDrawingSnapshot(snapshot,()=>{
          if(revision!==this.highDrawingRevision)return;
          for(let limit=Math.min(index+16,ranges.length);index<limit;index++){
            const lo=ranges[index],hi=Math.min(n,lo+1),points=segment(lo,hi);
            append(physical,points);count=physical.length;
            if(Math.min(hi,end)>Math.max(lo,start))append(active,segment(Math.max(lo,start),Math.min(hi,end)));
          }
          if(index<ranges.length){this.highDrawingFrame=requestAnimationFrame(step);return;}
          this.setConductorPaths(physical,this.physicalPath,physicalBack);this.setConductorPaths(active,this.activePath,activeBack);
          this.svg.setAttribute('data-display-point-count',String(count));
          this.svg.setAttribute('data-render-ready','true');
        });
        this.highDrawingFrame=requestAnimationFrame(step);
      }

      drawingLengthNumber(mm) {
        const value=Number(mm)/this.unitFactor();
        return this.displayNumber(value);
      }

      drawingLengthText(mm) {return `${this.drawingLengthNumber(mm)} ${this.unitName()}`;}

      annotationNode(parent,tag,attrs={},text='') {
        const node=document.createElementNS('http://www.w3.org/2000/svg',tag);
        for(const[key,value]of Object.entries(attrs))node.setAttribute(key,String(value));
        node.textContent=text;parent.appendChild(node);return node;
      }

      dimensionAnnotation(parent,{x1,y1,x2,y2,text,kind,font,extensions=[],vertical=false,labelPosition='inline',labelOffset=font*1.2,labelX=null}) {
        const group=this.annotationNode(parent,'g',{'data-annotation':kind});
        for(const extension of extensions)this.annotationNode(group,'line',{...extension,class:'extension-line','data-extension-for':kind});
        this.annotationNode(group,'line',{x1,y1,x2,y2,class:'dimension-line','data-dimension':kind});
        const dx=x2-x1,dy=y2-y1,length=Math.hypot(dx,dy)||1,ux=dx/length,uy=dy/length;
        const arrowLength=Math.min(font*.55,length*.22),arrowWidth=Math.min(font*.22,length*.09);
        for(const [tx,ty,direction]of[[x1,y1,1],[x2,y2,-1]]){
          const bx=tx+ux*arrowLength*direction,by=ty+uy*arrowLength*direction,px=-uy*arrowWidth,py=ux*arrowWidth;
          this.annotationNode(group,'path',{d:`M ${tx} ${ty} L ${bx+px} ${by+py} L ${bx-px} ${by-py} Z`,class:'dimension-arrow','data-arrow-for':kind});
        }
        if(labelPosition==='inline'&&!vertical&&length<text.length*font*.58+font)labelPosition='outside-below';
        let x=labelX===null?(x1+x2)/2:labelX,y=(y1+y2)/2,anchor='middle';
        if(labelPosition==='outside-right'){
          x=Math.max(x1,x2)+font*.9;anchor='start';
          this.annotationNode(group,'line',{x1:(x1+x2)/2,y1:(y1+y2)/2,x2:x-font*.25,y2:y,class:'dimension-leader','data-leader-for':kind});
        }else if(labelPosition==='outside-left'){
          x=Math.min(x1,x2)-font*.9;anchor='end';
          this.annotationNode(group,'line',{x1:(x1+x2)/2,y1:(y1+y2)/2,x2:x+font*.25,y2:y,class:'dimension-leader','data-leader-for':kind});
        }else if(labelPosition==='outside-below'){
          y=Math.max(y1,y2)+labelOffset;
          this.annotationNode(group,'line',{x1:(x1+x2)/2,y1:(y1+y2)/2,x2:x,y2:y-font*.3,class:'dimension-leader','data-leader-for':kind});
        }else if(labelPosition==='outside-above'){
          y=Math.min(y1,y2)-labelOffset;
          this.annotationNode(group,'line',{x1:(x1+x2)/2,y1:(y1+y2)/2,x2:x,y2:y+font*.3,class:'dimension-leader','data-leader-for':kind});
        }
        const attrs={x,y,'text-anchor':anchor,'dominant-baseline':'middle','font-size':font,'data-dimension-label':'','data-label-for':kind};
        if(vertical&&labelPosition==='inline')attrs.transform=`rotate(-90 ${x} ${y})`;
        this.annotationNode(group,'text',attrs,text);
        return group;
      }

      finishAnnotationLayout() {
        if(typeof this.svg.querySelectorAll!=='function')return;
        for(const node of this.svg.querySelectorAll('[data-dimension-label]')){
          if(typeof node.getBBox!=='function'||!node.parentNode?.insertBefore)continue;
          const box=node.getBBox(),font=Number(node.getAttribute('font-size')||0),pad=Math.max(font*.22,this.screenPixelsToSvgUnits(2));
          const background=document.createElementNS('http://www.w3.org/2000/svg','rect');
          for(const[key,value]of Object.entries({x:box.x-pad,y:box.y-pad*.45,width:box.width+2*pad,height:box.height+pad*.9,rx:pad*.35,class:'dimension-label-bg','data-label-bg-for':node.getAttribute('data-label-for')||''}))background.setAttribute(key,String(value));
          const transform=node.getAttribute('transform');if(transform)background.setAttribute('transform',transform);
          node.parentNode.insertBefore(background,node);
        }
      }

      drawParameterDiagram() {
        if(!this.parameterSvg)return;
        if(this.awaitingDrawing&&!this.renderContext){
          if(this.committedDrawing)this.withDrawingSnapshot(this.committedDrawing,()=>this.drawParameterDiagram());
          return;
        }
        const canvas=this.querySelector('.primary-calculator__parameter-canvas');
        const bounds=canvas?.getBoundingClientRect?.();
        const W=canvas?.clientWidth||bounds?.width||this.parameterSvg.getBoundingClientRect?.().width||640,H=canvas?.clientHeight||bounds?.height||this.parameterSvg.getBoundingClientRect?.().height||320;
        const layout=this.compactParameterLayout(W,H);
        if(!layout){
          const warning=this.querySelector('[data-parameter-scale-note]');
          if(warning)warning.textContent=this.dataset.labelLayoutUnavailable;
          return;
        }
        const renderW=layout.width||W,renderH=layout.height||H;
        if(canvas?.style){
          canvas.style.overflow=layout.expanded?'auto':'hidden';
          canvas.dataset.layoutMode=layout.expanded?'scroll':'compact';
          for(const node of [this.parameterSvg,this.querySelector('[data-parameter-connectors]'),this.querySelector('.primary-calculator__parameter-controls')])if(node?.style){node.style.width=renderW+'px';node.style.height=renderH+'px';}
        }
        this.parameterDiagram.dataset.diagramShape=this.shape();
        this.parameterSvg.dataset.conductor=this.isPcb()?'pcb':'round';
        this.parameterSvg.setAttribute('viewBox','0 0 '+renderW+' '+renderH);
        const set=(selector,attrs)=>{const node=this.parameterSvg.querySelector(selector);if(node)for(const[k,v]of Object.entries(attrs))node.setAttribute(k,String(v));return node;};
        set('[data-parameter-round-art]',{})?.toggleAttribute('hidden',this.isPcb());
        set('[data-parameter-pcb-art]',{})?.toggleAttribute('hidden',!this.isPcb());
        const {first,second,diameter,traceWidth,thickness,notes,groups}=layout;
        if(layout.expanded)notes.push('labelLayoutScroll');
        const tube=!this.isPcb()&&this.conductorForm()==='tube';
        const wall=tube?Math.min(diameter/2,Math.max(2,diameter*this.roundWall()/this.conductorWidth())):0;
        if(tube&&wall>diameter*this.roundWall()/this.conductorWidth()+1e-9)notes.push('labelWallEnlarged');
        if(!this.isPcb()){
          for(const[name,p]of [['first',first],['second',second]]){
            set('[data-parameter-turn="'+name+'"]',{cx:p.x,cy:p.y,r:diameter/2});
            set('[data-parameter-hole="'+name+'"]',{cx:p.x,cy:p.y,r:Math.max(0,diameter/2-wall)})?.toggleAttribute('hidden',!tube);
          }
          const mark=p=>'M '+(p.x-5)+' '+p.y+' H '+(p.x+5)+' M '+p.x+' '+(p.y-5)+' V '+(p.y+5);
          set('[data-parameter-centers]',{d:mark(first)+' '+mark(second)});
        }else{
          for(const[name,p]of [['first',first],['second',second]])set('[data-parameter-trace="'+name+'"]',{x:p.x,y:p.y,width:traceWidth,height:thickness,rx:0});
          const out=this.querySelector('[data-parameter-thickness-value]');if(out)out.textContent=this.lengthText(this.number('copper_thickness_mm'));
        }
        const extensions=[];
        for(const key of ['conductor','wall','radial','axial','trace-width','trace-gap','trace-thickness']){
          const g=groups.find(item=>item.name===key),node=this.parameterSvg.querySelector('[data-parameter-dimension="'+key+'"]');
          node?.toggleAttribute('hidden',!g);if(!g)continue;
          if(key==='conductor')set('[data-parameter-dimension="'+key+'"]',{x1:g.x1,y1:g.y1,x2:g.x2,y2:g.y2});
          else set('[data-parameter-dimension="'+key+'"]',{d:'M '+g.x1+' '+g.y1+' L '+g.x2+' '+g.y2});
          for(const e of g.extensions)extensions.push('M '+e[0]+' '+e[1]+' L '+e[2]+' '+e[3]);
        }
        set('[data-parameter-extensions="'+(this.isPcb()?'pcb':'round')+'"]',{d:extensions.join(' ')});
        this.parameterSvg.dataset.scaleAdjustments=notes.join(' ');
        const note=this.querySelector('[data-parameter-scale-note]');
        if(note)note.textContent=notes.length?notes.map(k=>this.dataset[k]).join(' · ')+' · '+this.dataset.labelActualDimensions:'';
        this.connectParameterCards(groups);
      }

      compactParameterLayout(W,H,expanded=false) {
        if(W<260&&!expanded)return this.compactParameterLayout(1024,640,true);
        const pcb=this.isPcb(),vertical=pcb||this.shape()!=='flat',areaW=Math.max(60,W-(vertical?164:40)),areaH=Math.max(72,H-208);
        const notes=[],top=104;
        let first,second,diameter=0,traceWidth=0,thickness=0,wall=0;
        if(!pcb){
          const od=this.conductorWidth(),pr=this.pitch(),pz=this.axialPitch(),ratio=Math.hypot(pr,pz)/od,f=ratio>6?6/ratio:1;
          if(ratio>6)notes.push('labelSpacingCompressed');
          const dx=pr/od*f,dy=pz/od*f;
          diameter=Math.min(96,areaW/(1+dx),areaH/(1+dy));
          const x=20+(areaW-diameter*(1+dx))/2+diameter/2,y=top+(areaH-diameter*(1+dy))/2+diameter/2;
          first={x,y:y+dy*diameter};second={x:x+dx*diameter,y};
          wall=this.conductorForm()==='tube'?Math.min(diameter/2,Math.max(2,diameter*this.roundWall()/od)):0;
        }else{
          const w=this.number('trace_width_mm'),gap=this.number('trace_gap_mm'),h=this.number('copper_thickness_mm'),ratio=Math.min(6,gap/w);
          traceWidth=Math.min(140,(areaW-8)/2,areaW/(2+ratio),areaH/(h/w));
          const visibleGap=Math.max(8,traceWidth*ratio);thickness=Math.max(4,traceWidth*h/w);
          if(gap/w>6)notes.push('labelSpacingCompressed');
          if(visibleGap>traceWidth*gap/w+1e-9)notes.push('labelGapEnlarged');
          if(thickness>traceWidth*h/w+1e-9)notes.push('labelThicknessEnlarged');
          const x=20+(areaW-2*traceWidth-visibleGap)/2,y=top+(areaH-thickness)/2;
          first={x,y};second={x:x+traceWidth+visibleGap,y};
        }
        const r=diameter/2,obstacles=[first,second].map(p=>pcb?{x:p.x,y:p.y,w:traceWidth,h:thickness}:{x:p.x-r,y:p.y-r,w:diameter,h:diameter});
        const low=Math.min(...obstacles.map(o=>o.y)),high=Math.max(...obstacles.map(o=>o.y+o.h)),left=Math.min(...obstacles.map(o=>o.x)),right=Math.max(...obstacles.map(o=>o.x+o.w));
        const specs=pcb?[
          {name:'trace-thickness',vertical:true,lo:first.y,hi:first.y+thickness,a:second.x+traceWidth,b:second.x+traceWidth,min:low,max:high,h:52},
          {name:'trace-width',lo:first.x,hi:first.x+traceWidth,a:first.y,b:first.y,min:low,max:high},
          {name:'trace-gap',lo:first.x+traceWidth,hi:second.x,a:first.y+thickness,b:first.y+thickness,min:low,max:high}
        ]:[
          ...(this.shape()==='flat'?[]:[{name:'axial',vertical:true,lo:second.y,hi:first.y,a:second.x,b:first.x,min:low,max:high}]),
          ...(wall?[{name:'wall',lo:second.x+r-wall,hi:second.x+r,a:second.y,b:second.y,min:second.y-r,max:second.y+r}]:[]),
          {name:'conductor',lo:first.x-r,hi:first.x+r,a:first.y,b:first.y,min:first.y-r,max:first.y+r},
          ...(this.isCylinder()?[]:[{name:'radial',lo:first.x,hi:second.x,a:first.y,b:second.y,min:low,max:high}])
        ];
        const intersects=(a,b,pad=5)=>a.x<b.x+b.w+pad&&a.x+a.w>b.x-pad&&a.y<b.y+b.h+pad&&a.y+a.h>b.y-pad;
        const segments=g=>[[g.x1,g.y1,g.x2,g.y2],...g.extensions];
        const crosses=(s,b)=>Math.max(s[0],s[2])>b.x-2&&Math.min(s[0],s[2])<b.x+b.w+2&&Math.max(s[1],s[3])>b.y-2&&Math.min(s[1],s[3])<b.y+b.h+2;
        const clamp=(v,lo,hi)=>Math.max(lo,Math.min(hi,v));
        let maxGap=40;
        const options=(s,placed)=>{
          const h=s.h||80,mid=(s.lo+s.hi)/2,candidates=[];
          const xs=s.vertical?[right+12,W-136,left-136,12]:[mid-62,s.lo,s.hi-124,12,W-136,...placed.flatMap(g=>[g.box.x+132,g.box.x-132])];
          const ys=s.vertical?[mid-h/2,12,H-h-12]:[s.max+12,s.min-h-12,H-h-12,12,(s.min+s.max-h)/2];
          for(const rawX of xs)for(const rawY of ys){
            const box={x:clamp(rawX,12,W-136),y:clamp(rawY,12,H-h-12),w:124,h};
            if(obstacles.some(o=>intersects(box,o))||placed.some(g=>intersects(box,g.box,8)))continue;
            if(s.vertical&&!(box.x>=right+8-1e-7||box.x+124<=left-8+1e-7))continue;
            const gap=s.vertical?Math.max(0,box.y-s.hi,s.lo-box.y-h):Math.max(0,box.x-s.hi,s.lo-box.x-124);
            if(gap>maxGap)continue;
            const above=box.y+h<=(s.a+s.b)/2,side=s.vertical?(box.x>=right?box.x-6:box.x+130):(above?box.y+h+4:box.y-4);
            const g={name:s.name,box,vertical:!!s.vertical,
              x1:s.vertical?side:s.lo,y1:s.vertical?s.lo:side,x2:s.vertical?side:s.hi,y2:s.vertical?s.hi:side,
              extensions:s.vertical?[[s.a,s.lo,side,s.lo],[s.b,s.hi,side,s.hi]]:[[s.lo,s.a,s.lo,side],[s.hi,s.b,s.hi,side]]};
            if(placed.some(other=>segments(g).some(s=>crosses(s,other.box))||segments(other).some(s=>crosses(s,box))))continue;
            g.score=s.vertical?Math.abs(box.y+h/2-mid):Math.abs(box.x+62-mid)+Math.min(Math.abs(box.y-s.max),Math.abs(box.y+h-s.min))+(above?4:0);
            candidates.push(g);
          }
          return candidates.sort((a,b)=>a.score-b.score);
        };
        const search=(i,placed)=>{
          if(i===specs.length)return placed;
          for(const g of options(specs[i],placed)){const found=search(i+1,[...placed,g]);if(found)return found;}
          return null;
        };
        let groups=search(0,[]);
        if(!groups){maxGap=80;groups=search(0,[]);}
        if(!groups)return expanded?null:this.compactParameterLayout(Math.max(W,1024),Math.max(H,640),true);
        return {first,second,diameter,traceWidth,thickness,notes,groups,width:W,height:H,expanded};
      }


      connectParameterCards(groups) {
        const layer=this.querySelector('[data-parameter-connectors]');
        if(!layer)return;
        const bounds=this.parameterSvg.getBoundingClientRect?.();
        layer.setAttribute('viewBox','0 0 '+(bounds?.width||640)+' '+(bounds?.height||320));layer.replaceChildren();
        const ordered=[];
        for(const g of groups){
          const card=this.querySelector(g.name==='trace-thickness'?'[data-parameter-thickness]':'[data-parameter-control="'+g.name+'"]');
          if(!card?.style)continue;
          card.style.left=g.box.x+'px';card.style.top=g.box.y+'px';
          card.dataset.dimensionFor=g.name;
          card.dataset.labelSide=g.vertical?'side':g.y1>g.box.y+g.box.h/2?'above':'below';
          if(g.name==='trace-thickness')continue;
          ordered.push({card,...g.box});
          const clamp=(v,lo,hi)=>Math.max(lo,Math.min(hi,v));
          const sx=g.vertical?g.x1:clamp(g.box.x+62,g.x1,g.x2),sy=g.vertical?clamp(g.box.y+g.box.h/2,g.y1,g.y2):g.y1;
          const tx=clamp(sx,g.box.x,g.box.x+g.box.w),ty=clamp(sy,g.box.y,g.box.y+g.box.h);
          this.annotationNode(layer,'path',{d:'M '+sx+' '+sy+' L '+tx+' '+ty,'data-connects-control':g.name,'data-source-x':sx,'data-source-y':sy,'data-target-x':tx,'data-target-y':ty});
        }
        const parent=this.querySelector('.primary-calculator__parameter-controls');
        if(parent?.contains&&!parent.contains(document.activeElement)){
          const sorted=ordered.sort((a,b)=>a.y-b.y||a.x-b.x).map(o=>o.card),current=[...parent.children].filter(n=>sorted.includes(n));
          if(sorted.some((n,i)=>n!==current[i]))for(const node of sorted)parent.appendChild(node);
        }
      }

      switchWindingDirection(direction) {
        if (!['cw','ccw'].includes(direction) || this.dragging) return;
        if ((this.windingDirection || 'ccw') === direction) return;
        this.windingDirection = direction;
        this.querySelectorAll('button[data-winding-direction]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.windingDirection===direction)));
        this.draw();
      }

      pointAt(turn) {
        const turns = Math.max(0.1, this.number('physical_turns'));
        const safeTurn = Math.max(0, Math.min(turns, turn));
        const angle = 2 * Math.PI * safeTurn;
        const radius = this.number('spiral_start_centerline_diameter_mm') / 2 + this.pitch() * safeTurn;
        const depth = radius * Math.sin(angle) * (this.windingDirection==='cw'?-1:1), z = this.axialPitch() * safeTurn;
        return { turn: safeTurn, x: radius * Math.cos(angle), y: this.isCylinder() ? -z : -depth, depth, z };
      }

      tangentAt(turn) {
        const angle = 2 * Math.PI * turn, pitch = this.pitch();
        const radius = this.number('spiral_start_centerline_diameter_mm') / 2 + pitch * turn;
        if (this.isCylinder()) return {x: -2 * Math.PI * radius * Math.sin(angle), y: -this.axialPitch()};
        return { x: pitch * Math.cos(angle) - 2 * Math.PI * radius * Math.sin(angle),
          y: (-pitch * Math.sin(angle) - 2 * Math.PI * radius * Math.cos(angle)) * (this.windingDirection==='cw'?-1:1) };
      }

      cylinderPathData(points) {
        const lines = [[],[]];
        let previous = -1;
        for (let i=1;i<points.length;i++) {
          const a=points[i-1],b=points[i];
          const side=(a.depth+b.depth)<-1e-9?1:0;
          lines[side].push(`${side!==previous?'M'+a.x.toFixed(4)+' '+a.y.toFixed(4):''} L${b.x.toFixed(4)} ${b.y.toFixed(4)}`);
          previous=side;
        }
        return lines.map(parts=>parts.join(' '));
      }

      setConductorPaths(points, front, back) {
        if (!this.isCylinder()) {
          front.setAttribute('d', this.path(points));
          back.setAttribute('d', '');
          return;
        }
        const lines=this.cylinderPathData(points);
        front.setAttribute('d',lines[0]);back.setAttribute('d',lines[1]);
      }

      screenPixelsToSvgUnits(pixels) {
        const matrix = this.svg.getScreenCTM();
        if (matrix) {
          const scaleX = Math.hypot(matrix.a, matrix.b);
          const scaleY = Math.hypot(matrix.c, matrix.d);
          const scale = Math.min(scaleX, scaleY);
          if (scale > 0) return pixels / scale;
        }
        const rect = this.svg.getBoundingClientRect();
        return rect.width > 0 ? pixels * this.svg.viewBox.baseVal.width / rect.width : pixels;
      }

      clientPoint(event) {
        const matrix = this.svg.getScreenCTM();
        if (matrix) {
          const point = this.svg.createSVGPoint();
          point.x = event.clientX;
          point.y = event.clientY;
          const transformed = point.matrixTransform(matrix.inverse());
          return { x: transformed.x, y: transformed.y };
        }
        return null;
      }

      nearestTurnToPoint(x, y) {
        let nearestIndex = 0;
        let nearestDistance = Infinity;
        const current = this.number(this.dragging === 'end' ? 'end_turn' : 'start_turn');
        this.points.forEach((point, index) => {
          const candidate = (point.x - x) ** 2 + (point.y - y) ** 2;
          if (candidate < nearestDistance - 1e-12 || (Math.abs(candidate-nearestDistance) <= 1e-12 && Math.abs(point.turn-current) < Math.abs(this.points[nearestIndex].turn-current))) {
            nearestDistance = candidate;
            nearestIndex = index;
          }
        });
        let low = this.points[Math.max(0, nearestIndex - 1)].turn;
        let high = this.points[Math.min(this.points.length - 1, nearestIndex + 1)].turn;
        const distanceAt = (turn) => {
          const point = this.pointAt(turn);
          return (point.x - x) ** 2 + (point.y - y) ** 2;
        };
        for (let iteration = 0; iteration < 18; iteration += 1) {
          const left = low + (high - low) / 3;
          const right = high - (high - low) / 3;
          if (distanceAt(left) <= distanceAt(right)) high = right;
          else low = left;
        }
        const nearest = (low + high) / 2;
        const snap = this.screenPixelsToSvgUnits(4);
        for (const endpoint of [0, this.number('physical_turns')]) {
          const tangent = this.tangentAt(endpoint);
          if (Math.abs(nearest-endpoint) < .001 && Math.abs(nearest-endpoint) * Math.hypot(tangent.x,tangent.y) <= snap) return endpoint;
        }
        return nearest;
      }

      updateMetalPaint(outer, diameter) {
        if (typeof SVGLinearGradientElement === 'undefined' || typeof crypto === 'undefined' || typeof crypto.randomUUID !== 'function') return;
        if (!this.metalPaint) {
          const prefix = `coil-metal-${crypto.randomUUID()}`;
          const defs = document.createElementNS('http://www.w3.org/2000/svg','defs');
          defs.setAttribute('data-metal-defs','');
          const create = (name, radial = false) => {
            const gradient = document.createElementNS('http://www.w3.org/2000/svg',radial ? 'radialGradient' : 'linearGradient');
            gradient.setAttribute('id',`${prefix}-${name}`);
            gradient.setAttribute('gradientUnits',name === 'main' || name === 'section' ? 'userSpaceOnUse' : 'objectBoundingBox');
            if (radial) { gradient.setAttribute('cx','.35'); gradient.setAttribute('cy','.30'); gradient.setAttribute('r','.75'); }
            else { gradient.setAttribute('x1','0'); gradient.setAttribute('y1','0'); gradient.setAttribute('x2','1'); gradient.setAttribute('y2','1'); }
            const stops = radial ? [[0,3],[.3,2],[.58,1],[1,0]] : [[0,0],[.2,1],[.42,2],[.48,3],[.54,4],[.72,5],[1,6]];
            for (const [offset,color] of stops) {
              const stop = document.createElementNS('http://www.w3.org/2000/svg','stop');
              stop.setAttribute('offset',offset); stop.setAttribute('stop-color',`var(--metal-${color})`); gradient.appendChild(stop);
            }
            defs.appendChild(gradient);
            this.svg.style.setProperty(`--coil-${name}-paint`,`url(#${prefix}-${name}) var(--coil-copper)`);
            return gradient;
          };
          this.metalPaint = {main:create('main'),section:create('section'),local:create('local'),circle:create('circle',true)};
          this.svg.appendChild(defs);
        }
        const extent = Math.max(.001,outer+diameter/2), height = this.axialPitch()*this.number('physical_turns');
        const setBounds = (gradient,top,bottom) => {
          gradient.setAttribute('x1',-extent); gradient.setAttribute('x2',extent);
          gradient.setAttribute('y1',top); gradient.setAttribute('y2',Math.max(top+.001,bottom));
        };
        setBounds(this.metalPaint.main,this.isCylinder() ? -height-diameter/2 : -extent,this.isCylinder() ? diameter/2 : extent);
        const half = (this.isPcb() ? this.number('copper_thickness_mm') : diameter)/2;
        setBounds(this.metalPaint.section,this.sectionBaseline-height-half,this.sectionBaseline+half);
      }

      draw() {
        if(this.awaitingDrawing&&this.committedDrawing){
          this.withDrawingSnapshot(this.committedDrawing,()=>this.drawConfirmed());
          this.disablePendingInteraction();return;
        }
        if(this.geometryIsValid()&&this.inputs)this.committedDrawing=this.captureDrawing();
        this.drawConfirmed();
      }

      drawConfirmed() {
        this.drawParameterDiagram();
        if (!this.geometryIsValid()) return;
        this.svg.setAttribute('data-display-unit',this.unitName());
        this.svg.setAttribute('data-winding-direction',this.windingDirection || 'ccw');
        if(this.acceptedTurns===undefined)this.acceptedTurns=this.number('physical_turns');
        this.svg.dataset.conductor = this.isPcb() ? 'pcb' : 'round';
        const diameter = this.conductorWidth();
        this.querySelector('[data-wall-note]').textContent = this.isPcb() ? '' : `${this.conductorForm()==='solid'?this.dataset.labelSolid:this.dataset.labelWall+': '+this.lengthText(this.roundWall())} · 10.000 kHz`;
        const highTurn = this.updateInteractionMode();
        const outer = this.number('spiral_start_centerline_diameter_mm') / 2 + this.pitch() * this.number('physical_turns');
        const radius = Math.max((outer + diameter / 2) * 1.18, this.axialPitch()*this.number('physical_turns')*.9);
        this.physicalPath.style.strokeLinecap = this.isPcb() ? 'butt' : 'round';
        this.activePath.style.strokeLinecap = this.isPcb() ? 'butt' : 'round';
        const width = this.svg.getBoundingClientRect().width || 480;
        const displayPlan=this.displayPlan(radius,width);
        this.svg.setAttribute('data-render-mode',displayPlan.mode);
        this.svg.removeAttribute('data-representative-turn-count');
        const drawingKey = JSON.stringify([this.windingDirection || 'ccw',this.unitName(),this.currentMaterial,this.conductorForm(),this.roundWall(), this.shape(), this.axialPitch(), diameter, this.pitch(), this.number('physical_turns'),
          this.number('spiral_start_centerline_diameter_mm'), this.number('copper_thickness_mm'), this.number('trace_gap_mm'), this.geometryRevision, Math.round(width),highTurn?this.number('start_turn'):null,highTurn?this.number('end_turn'):null]);
        if (drawingKey !== this.drawingKey) {
          this.drawingKey = drawingKey;
          this.drawingScreenWidth = width;
          this.querySelector('[data-high-elevation]').replaceChildren();
          if (this.shape() === 'flat') this.drawEngineeringSection(radius);
          else this.drawSpatialSection(radius);
          if(displayPlan.mode==='continuous'||displayPlan.mode==='envelope'){
            const title=this.querySelector('[data-engineering-guides]').children[0];
            if(title){
              const titleY=Number(title.getAttribute('y')),titleFont=Number(title.getAttribute('font-size'));
              this.annotationNode(title.parentNode,'text',{x:0,y:titleY+titleFont*1.3,'text-anchor':'middle','font-size':titleFont*.96,'data-render-note':''},displayPlan.mode==='continuous'?this.dataset.labelCenterlineDetail:this.dataset.labelDenseEnvelope);
            }
          }
          this.finishAnnotationLayout(radius);
          this.updateMetalPaint(outer,diameter);
          this.points = highTurn ? [] : this.samples();
          this.setConductorPaths(this.points,this.physicalPath,this.querySelector('[data-physical-back]'));
        }
        for (const path of [this.physicalPath, this.activePath,this.querySelector('[data-physical-back]'),this.querySelector('[data-active-back]')]) {
          path.setAttribute('stroke-width',String(diameter));
          path.style.fill='none';
        }
        for (const {node, turn} of this.sectionSlices || []) {
          node.setAttribute('opacity','1');
          node.setAttribute('data-unused',String(turn < this.number('start_turn') || turn > this.number('end_turn')));
        }
        if (highTurn) {
          this.points = [];
          this.renderHighWindings(displayPlan);
          this.previewReadout.textContent = `${this.dataset.labelPreviewGeometry} · START ${this.displayNumber(this.number('start_turn'))} · END ${this.displayNumber(this.number('end_turn'))} · N_eff ${this.displayNumber(this.number('end_turn') - this.number('start_turn'))} turn`;
          return;
        }
        this.highDrawingRevision=(this.highDrawingRevision||0)+1;
        cancelAnimationFrame(this.highDrawingFrame);
        this.highDrawingKey=null;
        this.svg.setAttribute('data-display-point-count',String(this.points.length));
        this.svg.setAttribute('data-render-ready','true');
        this.highPhysical.toggleAttribute('hidden', true);
        this.highActive.toggleAttribute('hidden', true);
        this.highCylinderPhysical.toggleAttribute('hidden', true);
        this.highCylinderActive.toggleAttribute('hidden', true);
        const start = this.number('start_turn');
        const end = this.number('end_turn');
        const active = [this.pointAt(start), ...this.points.filter((point) => point.turn > start && point.turn < end), this.pointAt(end)];
        this.setConductorPaths(active,this.activePath,this.querySelector('[data-active-back]'));
        Object.entries({ start: this.pointAt(start), end: this.pointAt(end) }).forEach(([name, point]) => {
          const handle = this.handles[name];
          const tangent = this.tangentAt(point.turn), angle = this.isCylinder() ? 0 : Math.atan2(tangent.y, tangent.x) * 180 / Math.PI;
          const unit = this.screenPixelsToSvgUnits(1);
          handle.setAttribute('transform', `translate(${point.x} ${point.y}) rotate(${angle}) scale(${unit})`);
          handle.setAttribute('aria-valuemin', name === 'start' ? '0' : String(start + .05));
          handle.setAttribute('aria-valuemax', String(name === 'start' ? end - .05 : this.number('physical_turns')));
          handle.setAttribute('aria-valuenow', point.turn.toFixed(6));
          const label = this.querySelector(`[data-tap-label="${name}"]`);
          const direction = (name === 'start' ? -1 : 1) * (point.x < 0 ? -1 : 1);
          label.setAttribute('x', String(Math.max(-radius + 38 * unit, Math.min(radius - 38 * unit, point.x + direction * 22 * unit))));
          label.setAttribute('y', String(point.y - 14 * unit));
          label.setAttribute('text-anchor', direction > 0 ? 'start' : 'end');
          label.setAttribute('font-size', String(11 * unit));
          const hitHandle = this.hitHandles[name];
          hitHandle.setAttribute('cx', String(point.x));
          hitHandle.setAttribute('cy', String(point.y));
          hitHandle.setAttribute('r', String(this.screenPixelsToSvgUnits(28)));
        });
        this.previewReadout.textContent = `${this.dataset.labelPreviewGeometry} · START ${this.displayNumber(start)} · END ${this.displayNumber(end)} · N_eff ${this.displayNumber(end - start)} turn`;
      }

      drawEngineeringSection(radius) {
        const group = this.querySelector('[data-pcb-section]');
        const guides = this.querySelector('[data-engineering-guides]');
        group.replaceChildren();
        guides.replaceChildren();
        this.sectionSlices = [];
        const pcb = this.isPcb();
        const width = this.conductorWidth(), thickness = pcb ? this.number('copper_thickness_mm') : width;
        const turns = this.number('physical_turns'), inner = this.number('spiral_start_centerline_diameter_mm');
        const outer = inner + 2 * this.pitch() * turns;
        const font = 11.5 * 2 * radius / (this.svg.getBoundingClientRect().width || 480);
        const mainBottom = outer / 2 + width / 2;
        this.mainInteractionBottom = mainBottom;
        const baseline = mainBottom + font * 5.5 + thickness / 2;
        this.sectionBaseline = baseline;
        const create = (tag, attributes, content, parent = group) => {
          const node = document.createElementNS('http://www.w3.org/2000/svg', tag);
          for (const [key, value] of Object.entries(attributes)) node.setAttribute(key, String(value));
          if (content) node.textContent = content;
          parent.appendChild(node); return node;
        };
        const line = (x1, y1, x2, y2, style = 'dimension-line', parent = group) => create('line', {x1,y1,x2,y2,class:style}, '', parent);
        const label = (x,y,content,anchor='middle',parent=group) => create('text', {x,y,'text-anchor':anchor,'font-size':font}, content, parent);
        label(-radius + font, -radius - font * .5, this.dataset.labelTopView, 'start', guides);
        create('circle', {cx:0,cy:0,r:inner/2,class:'projection-line'}, '', guides);
        label(-radius + font, mainBottom + font * 2.5, this.dataset.labelPcbSection, 'start');
        for (const x of [-outer/2,outer/2]) line(x,mainBottom+font*.3,x,baseline,'projection-line',guides);
        line(0,baseline-font,0,baseline+thickness/2+font*7,'projection-line');
        let sections = (this.renderContext?.pcbGeometry||this.pcbGeometry)?.section_points || [];
        if (!pcb) {
          const last = Math.floor(turns * 2 + 1e-10), step = Math.max(1, Math.ceil((last + 1) / 156));
          const indices = new Set([0,last,Math.min(1,last),Math.min(2,last)]);
          for (let i=0;i<=last;i+=step) indices.add(i);
          sections = [...indices].sort((a,b)=>a-b).map(i => [i/2, (i%2 ? -1 : 1)*(inner/2+this.pitch()*i/2),0]);
        }
        for (const [turn,x,z,low,high] of sections) {
          const node = pcb
            ? create('rect',{x:low,y:baseline-z-thickness/2,width:high-low,height:thickness,'data-turn':turn,class:'section-ribbon'})
            : create('circle',{cx:x,cy:baseline-z,r:width/2,'data-turn':turn,class:'section-circle'});
          this.sectionSlices.push({node,turn});
          if(!pcb)this.addSectionHole(group,x,baseline-z,width/2);
        }
        for (const [diameter,text,row,kind] of [[inner,this.dataset.labelInner,2.1,'inner-diameter'],[outer,this.dataset.labelOuter,5.2,'outer-diameter']]) {
          const y = baseline + thickness/2 + font*row;
          this.dimensionAnnotation(group,{x1:-diameter/2,y1:y,x2:diameter/2,y2:y,text:`${text} Ø${this.drawingLengthText(diameter)}`,kind,font,extensions:[
            {x1:-diameter/2,y1:baseline,x2:-diameter/2,y2:y},{x1:diameter/2,y1:baseline,x2:diameter/2,y2:y}
          ]});
        }
        const top = -radius - font*2.3;
        const height = baseline + thickness/2 + font*8 - top;
        this.svg.setAttribute('viewBox', `${-radius} ${top} ${2 * radius} ${height}`);
        this.svg.style.aspectRatio = `${2 * radius} / ${height}`;
        this.svg.setAttribute('data-mm-scale','1');
        this.svg.setAttribute('data-center-x','0');
        this.svg.setAttribute('data-section-zero-y',String(baseline));
        this.svg.setAttribute('data-main-zero-y','0');
        this.svg.setAttribute('data-main-kind','top_xy');
      }

      drawSpatialSection(radius) {
        const group=this.querySelector('[data-pcb-section]'),guides=this.querySelector('[data-engineering-guides]');
        group.replaceChildren();guides.replaceChildren();this.sectionSlices=[];
        const n=this.number('physical_turns'),d=this.conductorWidth(),r0=this.number('spiral_start_centerline_diameter_mm')/2;
        const pr=this.pitch(),pz=this.axialPitch(),r1=r0+pr*n,h=pz*n;
        const font=11.5*2*radius/(this.svg.getBoundingClientRect().width||480);
        const mainBottom=this.isCylinder()?d/2:r1+d/2, mainTop=this.isCylinder()?-h-d/2:-radius;
        const sectionTop=mainBottom+font*5.5+d/2,baseline=sectionTop+h;
        this.sectionBaseline=baseline;this.mainInteractionBottom=mainBottom;
        const create=(tag,attrs,text='',parent=group)=>{
          const node=document.createElementNS('http://www.w3.org/2000/svg',tag);
          for(const [key,value]of Object.entries(attrs))node.setAttribute(key,String(value));
          if(text)node.textContent=text;parent.appendChild(node);return node;
        };
        const line=(x1,y1,x2,y2,style='dimension-line',parent=group)=>create('line',{x1,y1,x2,y2,class:style},'',parent);
        const label=(x,y,text,parent=group)=>create('text',{x,y,'text-anchor':'middle','font-size':font},text,parent);
        label(0,mainTop-font*2.8,this.isCylinder()?this.dataset.labelSideView:this.dataset.labelTopView,guides);
        label(0,mainBottom+font*2.5,this.dataset.labelPcbSection);
        if(!this.isCylinder())create('circle',{cx:0,cy:0,r:r0,class:'projection-line'},'',guides);
        for(const sign of [-1,1]) {
          line(sign*r1,mainBottom+font*.3,sign*r1,sectionTop,'projection-line',guides);
          line(sign*r0,baseline,sign*r1,sectionTop,'projection-line');
        }
        line(0,sectionTop-font,0,baseline+d/2+font*2,'projection-line');
        const last=Math.floor(n*2+1e-10),step=Math.max(1,Math.ceil((last+1)/156)),indices=new Set([0,last,Math.min(1,last),Math.min(2,last)]);
        for(let i=0;i<=last;i+=step)indices.add(i);
        for(const i of [...indices].sort((a,b)=>a-b)) {
          const turn=i/2,x=(i%2?-1:1)*(r0+pr*turn),y=baseline-pz*turn;
          const node=create('circle',{cx:x,cy:y,r:d/2,class:'section-circle','data-turn':turn});
          this.addSectionHole(group,x,y,d/2);
          this.sectionSlices.push({node,turn});
        }
        const low=baseline+d/2;
        const diameterRow=this.isCylinder()?[[2*r0,this.dataset.labelCombinedDiameter,2.1,'combined-diameter']]:[[2*r0,this.dataset.labelInner,2.1,'inner-diameter'],[2*r1,this.dataset.labelOuter,5.2,'outer-diameter']];
        for(const [diameter,text,row,kind]of diameterRow) {
          const y=low+font*row;
          this.dimensionAnnotation(group,{x1:-diameter/2,y1:y,x2:diameter/2,y2:y,text:`${text} Ø${this.drawingLengthText(diameter)}`,kind,font,extensions:[
            {x1:-diameter/2,y1:baseline,x2:-diameter/2,y2:y},{x1:diameter/2,y1:baseline,x2:diameter/2,y2:y}
          ]});
        }
        const topRight=r1+d/2,bottomRight=r0+d/2,hx=Math.min(radius-font*1.4,Math.max(topRight,bottomRight)+font*2.5),heightText=`${this.dataset.labelHeight} ${this.drawingLengthText(h)}`;
        const heightLabelPosition=Math.abs(baseline-sectionTop)<heightText.length*font*.58+font?'outside-left':'inline';
        this.dimensionAnnotation(group,{x1:hx,y1:sectionTop,x2:hx,y2:baseline,text:heightText,kind:'centerline-height',font,vertical:true,labelPosition:heightLabelPosition,extensions:[
          {x1:topRight,y1:sectionTop,x2:hx,y2:sectionTop},{x1:bottomRight,y1:baseline,x2:hx,y2:baseline}
        ]});
        const drawingBottom=low+font*(this.isCylinder()?4.8:8);
        const top=mainTop-font*4.3,height=drawingBottom-top;
        this.svg.setAttribute('viewBox',`${-radius} ${top} ${2*radius} ${height}`);
        this.svg.style.aspectRatio=`${2*radius} / ${height}`;
        this.svg.setAttribute('data-mm-scale','1');this.svg.setAttribute('data-center-x','0');
        this.svg.setAttribute('data-section-zero-y',String(baseline));this.svg.setAttribute('data-main-zero-y','0');
        this.svg.setAttribute('data-main-kind',this.isCylinder()?'side_xz':'top_xy');
      }

      addSectionHole(group,x,y,radius) {
        if(this.conductorForm()!=='tube'||this.isPcb())return;
        const r=radius-this.roundWall();
        if(r>0)this.annotationNode(group,'circle',{cx:x,cy:y,r,class:'section-hole','data-section-hole':''});
      }

      startDrag(name, event) {
        if (!this.geometryIsValid()) return;
        if (this.isHighTurnMode() || this.dragging || (event.pointerType === 'mouse' && event.button !== 0)) return;
        event.preventDefault();
        event.stopPropagation();
        this.dragging = name;
        this.dragInitialTurn = this.number(`${name}_turn`);
        this.activePointerId = event.pointerId;
        this.svg.setPointerCapture(event.pointerId);
        this.invalidateResult();
      }

      moveHandleToPointer(event) {
        const point = this.clientPoint(event);
        if (!point) return;
        const nearestTurn = this.nearestTurnToPoint(point.x, point.y);
        const turns = Math.max(0.1, this.number('physical_turns'));
        const other = this.number(this.dragging === 'start' ? 'end_turn' : 'start_turn');
        const value = this.dragging === 'start'
          ? Math.max(0, Math.min(nearestTurn, other - 0.05))
          : Math.min(turns, Math.max(nearestTurn, other + 0.05));
        this.setFieldValue(`${this.dragging}_turn`,value);
        this.draw();
      }

      drag(event) {
        if (!this.dragging || event.pointerId !== this.activePointerId) return;
        event.preventDefault();
        this.pendingPointer = { clientX: event.clientX, clientY: event.clientY };
        if (!this.dragFrame) this.dragFrame = requestAnimationFrame(() => {
          this.dragFrame = null;
          if (this.dragging && this.pendingPointer) this.moveHandleToPointer(this.pendingPointer);
          this.pendingPointer = null;
        });
      }

      stopDrag(event) {
        if (!this.dragging || event.pointerId !== this.activePointerId) return;
        if (this.dragFrame) cancelAnimationFrame(this.dragFrame);
        this.dragFrame = null;
        if (event.type === 'pointerup' && this.pendingPointer) this.moveHandleToPointer(this.pendingPointer);
        if (event.type !== 'pointerup') {
          this.setFieldValue(`${this.dragging}_turn`,this.dragInitialTurn);
          this.draw();
        }
        this.pendingPointer = null;
        this.dragging = null;
        this.activePointerId = null;
        if (this.svg.hasPointerCapture(event.pointerId)) this.svg.releasePointerCapture(event.pointerId);
        if (this.isPcb()) this.scheduleExact(400);
        else if (event.type === 'pointerup') this.requestExact();
        else this.scheduleExact(0);
      }

      scheduleExact(delay) {
        clearTimeout(this.timer);
        if(this.awaitingDrawing||this.draftDirty||(this.isPcb()&&!this.solverAvailable()))return;
        this.timer = setTimeout(() => this.requestExact(), delay);
      }

      payload() {
        const connection = { mode: 'measured_pair', length_a_mm: 0, length_b_mm: 0, paired_length_mm: 0, extra_unpaired_inductance_uh: 0 };
        const payload = {};
        this.inputs.forEach((input) => {
          const value = input.tagName === 'SELECT' ? input.value : this.number(input.dataset.field);
          if (!input.dataset.field.startsWith('connection.')) payload[input.dataset.field] = value;
        });
        if (this.isPcb()) return { ...this.pcbGeometryPayload(), start_turn: this.number('start_turn'), end_turn: this.number('end_turn'), solver_mode: 'fast', connection };
        delete payload.trace_width_mm;
        delete payload.trace_gap_mm;
        delete payload.copper_thickness_mm;
        delete payload.axial_pitch_mm;
        payload.wall_thickness_mm = Math.min(1, payload.conductor_od_mm / 2);
        payload.frequency_khz = 10;
        payload.connection = connection;
        return payload;
      }

      roundCoilPayload() {
        return {shape:this.shape(),start_centerline_diameter_mm:this.number('spiral_start_centerline_diameter_mm'),
          conductor_form:this.conductorForm(),...(this.conductorForm()==='tube'?{wall_thickness_mm:this.roundWall()}:{}),
          conductor_od_mm:this.conductorWidth(),physical_turns:this.number('physical_turns'),radial_pitch_mm:this.pitch(),axial_pitch_mm:this.axialPitch(),
          start_turn:this.number('start_turn'),end_turn:this.number('end_turn')};
      }

      roundResultValid(result) {
        const input=this.roundCoilPayload();
        const checks={inner_centerline_diameter_mm:input.start_centerline_diameter_mm,
          outer_centerline_diameter_mm:input.start_centerline_diameter_mm+2*input.radial_pitch_mm*input.physical_turns,
          total_centerline_height_mm:input.axial_pitch_mm*input.physical_turns,
          effective_turns:input.end_turn-input.start_turn,frequency_khz:10,effective_wall_thickness_mm:this.roundWall()};
        return this.shape()===input.shape && result.shape===input.shape && ['peec_360','maxwell_turn_loop'].includes(result.solver_method)
          && Object.entries(checks).every(([key,value])=>Number.isFinite(result[key])&&Math.abs(result[key]-value)<=1e-8*Math.max(1,Math.abs(value)));
      }

      endpoint(route = 'primary-inductance') {
        const base = this.dataset.apiEndpoint.trim().replace(/\/$/, '');
        if (!base) return '';
        const service = base.replace(/\/api\/v1\/(primary-inductance|coil-inductance|pcb-inductance|pcb-geometry)$/, '');
        return `${service}/api/v1/${route}`;
      }

      async refreshCacheVersion(signal) {
        const endpoint = this.endpoint('pcb-inductance');
        const now = Date.now(), previous = this.cacheVersion;
        if (previous && previous.endpoint === endpoint && now >= previous.checkedAt && now - previous.checkedAt < 60000) return this.cacheVersionForCurrent(previous);
        const controller = new AbortController();
        const abort = () => controller.abort();
        signal?.addEventListener('abort', abort, { once: true });
        if (signal?.aborted) controller.abort();
        const timer = setTimeout(abort, 1500);
        try {
          const response = await fetch(endpoint.replace(/\/api\/v1\/pcb-inductance$/, '/health'), {signal:controller.signal,cache:'no-store'});
          const health = await response.json();
          if (controller.signal.aborted) throw new Error('Version request cancelled');
          if (!response.ok || health.status !== 'ok' || typeof health.model_version !== 'string' || !health.model_version || typeof health.pcb_fast_solver_version !== 'string' || !health.pcb_fast_solver_version) throw new Error('Missing cache version');
          const version = {endpoint,model:health.model_version,algorithm:health.pcb_fast_solver_version,thickAlgorithm:health.pcb_thick_solver_version||null,geometry:health.pcb_geometry_version||null,limits:health.pcb_fast_limits||null,checkedAt:Date.now()};
          if (previous && (previous.endpoint !== endpoint || previous.model !== version.model || previous.algorithm !== version.algorithm || previous.thickAlgorithm!==version.thickAlgorithm || previous.geometry!==version.geometry || JSON.stringify(previous.limits)!==JSON.stringify(version.limits))) this.pcbResultCache?.clear();
          this.cacheVersion = version;
          return this.cacheVersionForCurrent(version);
        } catch (_) {
          this.cacheVersion = null;
          this.pcbResultCache?.clear();
          return null;
        } finally {
          clearTimeout(timer);
          signal?.removeEventListener('abort', abort);
        }
      }

      cacheVersionForCurrent(version) {
        if(this.number('copper_thickness_mm')<=.07)return version;
        return version.thickAlgorithm?{...version,algorithm:version.thickAlgorithm}:null;
      }

      pcbCacheKey(payload, version) {
        return JSON.stringify(['dcr20-v1',version.endpoint,version.model,version.algorithm,version.geometry||null,10,payload]);
      }

      readPcbCache(payload, version) {
        if (!version) return null;
        const key = this.pcbCacheKey(payload, version), entry = this.pcbResultCache?.get(key), now = Date.now();
        if (!entry) return null;
        if(!Number.isFinite(entry.result.dc_resistance_ohm)||entry.result.dc_resistance_ohm<=0||entry.result.dcr_temperature_c!==20){this.pcbResultCache.delete(key);return null;}
        if (now < entry.createdAt || now - entry.createdAt >= 300000) { this.pcbResultCache.delete(key); return null; }
        this.pcbResultCache.delete(key);
        this.pcbResultCache.set(key, entry);
        return JSON.parse(JSON.stringify(entry.result));
      }

      storePcbCache(payload, version, result) {
        if (!version || !this.meshResultValid(result) || result.ok === false || result.dcr_temperature_c!==20 || !['l_spiral_total_uh','active_length_mm','dc_resistance_ohm'].every(k=>Number.isFinite(result[k])&&result[k]>0)) return;
        if (result.model_version !== version.model || result.solver_method !== version.algorithm || result.frequency_khz !== 10 || result.solver_mode !== 'fast') {
          this.cacheVersion = null;
          this.pcbResultCache?.clear();
          return;
        }
        this.pcbResultCache ||= new Map();
        const key = this.pcbCacheKey(payload,version);
        this.pcbResultCache.delete(key);
        this.pcbResultCache.set(key,{createdAt:Date.now(),result:JSON.parse(JSON.stringify(result))});
        while (this.pcbResultCache.size > 32) this.pcbResultCache.delete(this.pcbResultCache.keys().next().value);
      }

      pcbResponse(endpoint, payload, signal) {
        return new Promise((resolve, reject) => {
          const socket = new WebSocket(endpoint.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:') + '-ws');
          let settled = false, cancelError = null, cancelTimer = null;
          const abortError = () => Object.assign(new Error('Cancelled'), { name: 'AbortError' });
          const finish = (error, result) => {
            if (settled) return;
            settled = true;
            clearTimeout(budgetTimer);
            clearTimeout(cancelTimer);
            signal.removeEventListener('abort', onAbort);
            socket.close();
            if (error) reject(error);
            else resolve({ ok: true, json: async () => result });
          };
          const cancel = (error) => {
            if (settled || cancelError) return;
            cancelError = error;
            if (socket.readyState === WebSocket.OPEN) {
              socket.send(JSON.stringify({ type: 'cancel' }));
              cancelTimer = setTimeout(() => finish(cancelError), 8000);
            } else finish(cancelError);
          };
          const onAbort = () => cancel(abortError());
          const budgetTimer = setTimeout(() => cancel(new Error(this.dataset.messageTimeout)), 45000);
          signal.addEventListener('abort', onAbort, { once: true });
          socket.onopen = () => {
            if (signal.aborted) onAbort();
            else socket.send(JSON.stringify({ type: 'calculate', payload }));
          };
          socket.onmessage = (event) => {
            let message;
            try { message = JSON.parse(event.data); }
            catch (_) { finish(new Error(this.dataset.messageSocketError)); return; }
            if (cancelError) {
              if (['cancelled', 'error', 'result'].includes(message.type)) finish(cancelError);
            } else if (message.type === 'result') finish(null, message.result);
            else if (message.type === 'error') finish(new Error(message.detail || this.dataset.messageSocketError));
            else if (message.type === 'cancelled') finish(abortError());
            else finish(new Error(this.dataset.messageSocketError));
          };
          socket.onerror = () => finish(cancelError || new Error(this.dataset.messageSocketError));
          socket.onclose = () => finish(cancelError || new Error(this.dataset.messageSocketError));
          if (signal.aborted) onAbort();
        });
      }

      async requestExact(explicit = false) {
        if(this.awaitingDrawing||this.draftDirty)return;
        if(this.isHighTurnMode()&&this.inputsAreValid()){
          this.querySelector('[data-field="start_turn"]').value='0';
          this.querySelector('[data-field="end_turn"]').value=String(this.number('physical_turns'));
        }
        if (this.isPcb() && !this.pcbGeometry) return;
        if (this.isPcb() && !this.solverAvailable()) { this.updatePcbCompute(); return; }
        if (this.isPcb() && this.controller && !this.controller.signal.aborted) return;
        if (!this.geometryIsValid()) return;
        const endpoint = this.endpoint(this.isPcb() ? 'pcb-inductance' : 'coil-inductance');
        if (!endpoint) {
          this.setStatus('error');
          this.message.textContent = this.dataset.messageNoEndpoint;
          return;
        }
        if (this.controller) this.controller.abort();
        const controller = new AbortController();
        this.controller = controller;
        this.retryAvailable=false;this.updatePcbCompute();
        const sequence = ++this.sequence;
        const requestStarted = Date.now();
        this.setStatus('loading');
        this.querySelector('[data-calculate]').disabled = true;
        this.querySelector('[data-cancel]').disabled = false;
        this.message.textContent = '';
        this.querySelector('[data-cache-note]').textContent = '';
        try {
          const payload = this.isPcb() ? this.payload() : this.roundCoilPayload();
          const version = this.isPcb() ? await this.refreshCacheVersion(controller.signal) : null;
          if (sequence !== this.sequence || controller.signal.aborted) return;
          const cached = this.isPcb() ? this.readPcbCache(payload,version) : null;
          const response = cached ? {ok:true,json:async()=>cached} : this.isPcb() ? await this.pcbResponse(endpoint, payload, controller.signal) : await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            signal: controller.signal
          });
          const result = await response.json();
          if (sequence !== this.sequence || controller.signal.aborted) return;
          if (!response.ok || result.ok === false) throw new Error(typeof result.detail === 'string' ? result.detail : `HTTP ${response.status}`);
          if (['l_spiral_total_uh', 'active_length_mm'].some((name) => !Number.isFinite(result[name]))) throw new Error('Invalid solver result');
          if(!Number.isFinite(result.dc_resistance_ohm)||result.dc_resistance_ohm<=0||result.dcr_temperature_c!==20)throw new Error('Invalid DCR result');
          if (!this.isPcb() && !this.roundResultValid(result)) throw new Error('Coil geometry/result mismatch');
          const meshNames = ['angular', 'cross_section', 'quadrature',...(this.isPcb()&&this.number('copper_thickness_mm')>.07?['thickness']:[])];
          if (this.isPcb() && !this.meshResultValid(result)) throw new Error('Missing or unconverged mesh validation');
          if (this.isPcb() && version && (result.model_version !== version.model || result.solver_method !== version.algorithm)) {
            this.cacheVersion = null;
            this.pcbResultCache?.clear();
            throw new Error(this.dataset.messageVersionChanged);
          }
          if (this.isPcb() && !cached) this.storePcbCache(payload,version,result);
          this.resultLengthMm=result.active_length_mm;
          this.querySelector('[data-result="l_spiral_total_uh"]').textContent=this.displayNumber(result.l_spiral_total_uh);
          this.querySelector('[data-result="active_length_mm"]').textContent=this.resultLengthNumber(this.resultLengthMm);
          const milli=result.dc_resistance_ohm<1;
          this.querySelector('[data-result="dc_resistance_ohm"]').textContent=this.displayNumber(result.dc_resistance_ohm*(milli?1000:1));
          this.querySelector('[data-result-dcr-unit]').textContent=milli?'mΩ':'Ω';
          this.setStatus('exact');
          this.querySelector('[data-cache-note]').textContent = cached ? this.dataset.labelCached : '';
          this.dataset.lastResultSource = cached ? 'session-cache' : 'server';
          this.dataset.lastResultElapsedMs = String(Date.now() - requestStarted);
          const effectiveTurns = this.number('end_turn') - this.number('start_turn');
          this.message.textContent = `${this.isPcb() ? this.dataset.labelPcbResult : (effectiveTurns > 20 ? this.dataset.labelRoundFast : '')} ${result.solver_method || ''}`;
          const warnings = result.warnings || [];
          this.querySelector('[data-server-diagnostics]').hidden = warnings.length === 0;
          this.querySelector('[data-server-warnings]').textContent = warnings.join('\n');
          const start = this.number('start_turn'), end = this.number('end_turn');
          const fractionalEnds = Math.abs(start - Math.round(start)) > 1e-10 && Math.abs(end - Math.round(end)) > 1e-10 && Math.floor(end) > Math.ceil(start);
          const modelRisk = this.isPcb() ? (result.applicability?.within_small_slope_guideline === false || result.applicability?.boundary_annulus_overlap_risk || fractionalEnds) : result.solver_accuracy_status === 'warning';
          if (modelRisk) this.message.textContent += ` · ${this.dataset.labelModelRisk}`;
          if (this.isPcb()) this.message.textContent += ` · ${this.dataset.labelMesh}: ${meshNames.map(name => result.mesh_checks[name] === 'not_applicable' ? this.dataset.labelNotApplicable : this.displayNumber(result.mesh_errors[name] * 100) + '%').join(' / ')}`;
        } catch (error) {
          if (error.name === 'AbortError' || sequence !== this.sequence) return;
          this.setStatus('error');
          this.retryAvailable=true;
          this.message.textContent = `${this.dataset.messageApiError} ${error.message}`;
        } finally {
          if (sequence === this.sequence) {
            this.controller = null;
            this.querySelector('[data-cancel]').disabled = true;
            this.updatePcbCompute();
          }
        }
      }

      setStatus(state) {
        if (state === 'preview' && this.isPcb() && !this.solverAvailable()) state = 'unsupported';
        const labels = { preview: this.dataset.labelPreview, loading: this.dataset.labelLoading, exact: this.dataset.labelExact,
          error: this.dataset.labelError, invalid: this.dataset.labelInvalid, unsupported: this.dataset.labelUnsupported };
        this.status.dataset.state = state;
        const hasResult=state==='exact';
        this.status.textContent=hasResult?'':labels[state];
        this.status.hidden=hasResult;
        this.querySelector('[data-result="l_spiral_total_uh"]').hidden=!hasResult;
        this.querySelector('[data-inductance-unit]').hidden=!hasResult;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
